var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('b-collapse', {
    attrs: {
      "visible": true,
      "appear": ""
    }
  }, [!_vm.dispatchRequestFilters.dispatchDateGroup ? _c('b-collapse', {
    attrs: {
      "visible": true
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-card-title', [_vm._v("SELECTEER TYPE ORDERS")]), _c('b-form', [_c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('b-thead', [_c('tr', [_c('th'), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DISPATCH_DATE_GROUPS.overdue))]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DISPATCH_DATE_GROUPS.today))]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DISPATCH_DATE_GROUPS.next_day))])])]), _c('b-tbody', [_vm._l(_vm.batchTypesWithOrderCountsFiltered, function (batchType) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(batchType.display_name))]), _vm._l(_vm.DISPATCH_DATE_GROUPS, function (name, group) {
      return _c('td', {
        staticClass: "text-center"
      }, [batchType.dispatch_requests[group] ? _c('b-button', {
        staticClass: "py-0 px-1 font-size-lg",
        attrs: {
          "variant": "link",
          "size": "sm"
        },
        on: {
          "click": function ($event) {
            return _vm.selectDispatchRequestFilters(batchType.identifier, group);
          }
        }
      }, [_vm._v(" " + _vm._s(batchType.dispatch_requests[group]) + " ")]) : _c('span', [_vm._v("0")])], 1);
    })], 2);
  }), !_vm.batchTypesWithOrderCountsFiltered.length ? _c('tr', [_c('td', {
    staticClass: "pt-4",
    attrs: {
      "colspan": "3"
    }
  }, [_c('i', [_vm._v("Geen orders gevonden")])])]) : _vm._e()], 2)], 1)], 1)], 1), _c('div', {
    staticClass: "ml-2 font-size-lg"
  }, [_c('i', [_vm._v("OF")])]), _c('b-card', {
    staticClass: "my-2"
  }, [_c('b-card-title', [_vm._v("BATCH SPECIFIEKE ORDER")]), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.getDispatchRequestForSpecificOrder.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.isCreating || _vm.isCreatingFromSpecificOrder,
      "placeholder": "order nummer",
      "autocomplete": "off"
    },
    model: {
      value: _vm.orderIdentifier,
      callback: function ($$v) {
        _vm.orderIdentifier = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "orderIdentifier"
    }
  }), _c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.isCreating || _vm.isCreatingFromSpecificOrder
    }
  }, [_vm.isCreatingFromSpecificOrder ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Aanmaken")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm.isLoadingSortLocations ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('h3', [_vm._v(" Orders: "), _c('span', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.selectedBatchType.display_name) + " ")]), _c('span', {
    staticClass: "align-text-top"
  }, [_vm._v("→")]), _c('span', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.DISPATCH_DATE_GROUPS[_vm.dispatchRequestFilters.dispatchDateGroup]))]), _c('b-button', {
    staticClass: "p-0 ml-4",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": _vm.resetDispatchRequestFilters
    }
  }, [_vm._v("wijzig")])], 1)])], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('b-card', {
    staticClass: "mb-4"
  }, [_c('b-card-title', [_vm._v("INFORMATIE")]), _c('b-table-simple', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "borderless": "",
      "head-row-variant": "light"
    }
  }, [_c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Totaal aantal orders:")])]), _c('b-td', [_vm._v(_vm._s(_vm.dispatchRequests.length))])], 1), _c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Aantal orders voor geselecteerde pickzones:")])]), _c('b-td', [_vm._v(_vm._s(_vm.dispatchRequestsInSelectedPickZones.length))])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-card-title', [_vm._v(" BATCH AANTAL ORDERS "), _c('font-awesome-icon', {
    staticClass: "text-primary ml-2",
    attrs: {
      "icon": "question-circle",
      "title": "Als je een getal kiest dat lager is dan het aantal geselecteerde orders worden de orders met de oudste dispatchdatum eerst gekozen."
    }
  })], 1), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.getDispatchRequestForRecentOrders.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.dispatchRequestsInSelectedPickZones.length,
      "required": "",
      "disabled": _vm.isCreating,
      "placeholder": "aantal",
      "autocomplete": "off"
    },
    model: {
      value: _vm.recentOrderCount,
      callback: function ($$v) {
        _vm.recentOrderCount = _vm._n($$v);
      },
      expression: "recentOrderCount"
    }
  }), _c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isCreateFromRecentOrdersButtonEnabled
    }
  }, [_vm.isCreatingFromRecentOrders ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Aanmaken")])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('b-card', [_c('b-card-title', {
    staticClass: "mb-4"
  }, [_c('h5', [_c('strong', [_vm._v("KIES PICKZONES")])])]), _vm.isLoadingSortLocations ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('b-row', _vm._l(_vm.pickZonesChunked, function (pickZonesChunk) {
    return _c('b-col', {
      key: pickZonesChunk[0].id,
      attrs: {
        "cols": "6"
      }
    }, [_c('b-table-simple', {
      attrs: {
        "small": ""
      }
    }, [_c('colgroup', [_c('col', {
      staticStyle: {
        "width": "50px"
      }
    }), _c('col', {
      staticStyle: {
        "width": "150px"
      }
    }), _c('col')]), _c('thead', [_c('tr', [_c('th'), _c('th', [_vm._v("Aantal orders")]), _c('th', [_vm._v("Pickzone")])])]), _c('tbody', _vm._l(pickZonesChunk, function (pickZone) {
      return _c('tr', {
        key: pickZone.id,
        class: {
          'pickzone-selected': _vm.isZoneSelected(pickZone)
        }
      }, [_c('td', [_c('b-checkbox', {
        attrs: {
          "size": "lg",
          "switch": ""
        },
        on: {
          "input": function ($event) {
            return _vm.toggleZone(pickZone);
          }
        }
      })], 1), _c('td', [_vm._v(_vm._s(pickZone.drqCount))]), _c('td', [_c('span', {
        staticClass: "font-size-lg",
        domProps: {
          "innerHTML": _vm._s(pickZone.display_name)
        }
      })])]);
    }), 0)])], 1);
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }